module.exports = "<main>\r\n    Welcome\r\n</main>";


//////////////////
// WEBPACK FOOTER
// ./src/app/home/welcome.component.html
// module id = 412
// module chunks = 0